import dayjs from 'dayjs';
import apiClient from '../../../requests/api/apiClient';
import { ChartFiltersDouble } from '../types';
import {
  buildCategories,
  buildCategoriesFromDates,
} from '../utils';

const calculateKcSeriesData = (
  data: Record<string, any>,
  days: string[],
) => days.map((day) => {
  const dayData = data[day];
  if (!dayData) return null;

  return {
    x: dayjs(day).valueOf(),
    y: dayData,
    custom: {
      date: dayjs(day).format('YYYY-MM-DD'),
    },
  };
}).filter(Boolean);

const prepareData = async (filters: ChartFiltersDouble, telemetryType?: string) => {
  const granularity = 'daily'; // getGranularity(filters.startDate, filters.endDate);

  const {
    data: {
      kcData,
    },
  } = await apiClient.readings.getKcData({
    farmId: filters.farmId,
    startDate: filters.startDate,
    endDate: filters.endDate,
    sectorId: filters.sectorId || '',
    wiseconnZoneId: filters.wiseconnZoneId || '',
    weatherZoneId: filters.weatherZoneId || '',
    telemetryType: telemetryType || 'wiseconn',
    sn: filters.telemetryType === 'sn' ? filters.sn : undefined,
    chart: filters.chart,
  });

  const accumulatedKc: Record<string, any> = {};

  kcData.forEach((kc: { date: string; kc: number }) => {
    accumulatedKc[kc.date] = kc.kc;
  });

  const absoluteCategories = buildCategoriesFromDates(
    filters.startDate, filters.endDate,
  );

  const kcChartData = calculateKcSeriesData(accumulatedKc, absoluteCategories);

  const chartCategories = buildCategories(
    granularity,
    absoluteCategories,
  );

  const result = {
    kc: kcChartData,
    categories: chartCategories,
    absoluteCategories,
  };
  return result;
};

export default prepareData;
